import request from '@/utils/request'
import router from '@/router'

export default {
    linkFBAccount: async({ dispatch, commit }, accessToken) => {
        await request({ method: 'post', url: 'auth/facebook/link', data: { accessToken }})
            .then(res => {
                if (res.data && res.data.account && res.data.account.fb) {
                    commit('SET_FB', res.data.account.fb, { root: true })
                }
            })
            .catch(error => {
                commit('SET_FB', false, { root: true })
                if (error.response && error.response.data && error.response.data.message) {
                    dispatch('addMessage', {
                        message: error.response.data.message,
                        type: 'error',
                        locale: true
                    }, { root: true })
                }
            })
    },
    unlinkFBAccount: async({ dispatch, commit }) => {
        await request({ method: 'post', url: 'auth/facebook/unlink' })
            .then((res) => {
                if (res.data && res.data.account && !res.data.account.fb) {
                    commit('SET_FB', res.data.account.fb, { root: true })
                }
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.message) {
                    dispatch('addMessage', {
                        message: error.response.data.message,
                        type: 'error',
                        locale: true
                    }, { root: true })
                }
            })
    },
    loginFB: async({ dispatch, commit }, accessToken) => {
        await request({ method: 'post', url: 'auth/facebook/login', data: { accessToken }})
            .then((res) => {
                if (res.data && res.data.token) {
                    commit('SET_TOKEN', res.data.token, { root: true })
                    dispatch('addMessage', {
                        message: 'login',
                        type: 'success',
                        locale: true
                    }, { root: true })

                    router.push('/')
                }
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.message) {
                    dispatch('addMessage', {
                        message: error.response.data.message,
                        type: 'error',
                        locale: true
                    }, { root: true })
                }
            })
    },
    loginGoogle: async({ dispatch, commit }, accessToken) => {
        await request({ method: 'post', url: 'auth/google/login', data: { accessToken }})
            .then((res) => {
                if (res.data && res.data.token) {
                    commit('SET_TOKEN', res.data.token, { root: true })
                    dispatch('addMessage', {
                        message: 'login',
                        type: 'success',
                        locale: true
                    }, { root: true })

                    const redirectPages = {
                        admin: '/payments',
                        leader: '/dashboard',
                        business: '/referral-codes'
                    }

                    router.push(redirectPages[res.data.profile.type])
                }
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.message) {
                    dispatch('addMessage', {
                        message: error.response.data.message,
                        type: 'error',
                        locale: true
                    }, { root: true })
                }
            })
    },
    linkGoogleAccount: async({ dispatch, commit }, accessToken) => {
        await request({ method: 'post', url: 'auth/google/link', data: { accessToken }})
            .then(res => {
                if (res.data && res.data.account && res.data.account.google) {
                    commit('SET_GOOGLE', res.data.account.google, { root: true })
                }
            })
            .catch(error => {
                commit('SET_GOOGLE', false, { root: true })
                if (error.response && error.response.data && error.response.data.message) {
                    dispatch('addMessage', {
                        message: error.response.data.message,
                        type: 'error',
                        locale: true
                    }, { root: true })
                }
            })
    },
    unlinkGoogleAccount: async({ dispatch, commit }) => {
        await request({ method: 'post', url: 'auth/google/unlink' })
            .then((res) => {
                if (res.data && res.data.account && !res.data.account.google) {
                    commit('SET_GOOGLE', res.data.account.google, { root: true })
                }
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.message) {
                    dispatch('addMessage', {
                        message: error.response.data.message,
                        type: 'error',
                        locale: true
                    }, { root: true })
                }
            })
    },
    changePassword: async({ dispatch }, passData) => {
        await request({ method: 'put', url: 'account/password', data: { ...passData }})
            .then((_) => {
                dispatch('addMessage', {
                    message: 'passwordChanged',
                    type: 'success',
                    locale: true
                }, { root: true })
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.message) {
                    dispatch('addMessage', {
                        message: error.response.data.message,
                        type: 'error',
                        locale: true
                    }, { root: true })
                }
            })
    },
    updateAccount: async({ dispatch, commit }, data) => {
        await request({ method: 'put', url: 'account', data })
            .then(res => {
                if (res.data && res.data.account) {
                    dispatch('addMessage', {
                        message: 'accountUpdated',
                        type: 'success',
                        locale: true
                    }, { root: true })

                    commit('UPDATE_USER', res.data.account, { root: true })
                }
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.message) {
                    dispatch('addMessage', {
                        message: error.response.data.message,
                        type: 'error',
                        locale: true
                    }, { root: true })
                }
            })
    }
}
